import React from 'react'
import { Box, TextField,Grid, Slider,Select,MenuItem, FormControl,InputLabel, Typography } from '@mui/material';
import { AlignHorizontalLeft, AlignHorizontalRight, AlignVerticalBottom, AlignVerticalTop,BorderOuter,RoundedCorner } from '@mui/icons-material';

import useEmailEditorStore from '../../utilities/emailEditorStore';

function ContainerBlockProperties({ blockId }) {

    const { getBlockById, updateBlockProperties } = useEmailEditorStore();
  
  // Get the current block data from the store
  const block = getBlockById(blockId);
  
  if (!block) {
    return <Typography>Block not found</Typography>;
  }
  
  // Provide default properties if properties is undefined
  const properties = block.properties || {};

  // Generic property change handler
  const handlePropertyChange = (propertyName, value) => {
    updateBlockProperties(blockId, { [propertyName]: value });
  };
  // Specific handler for padding changes
  const handlePaddingChange = (side, value) => {
    const currentPadding = properties.padding || { top: 0, right: 0, bottom: 0, left: 0 };
    const newPadding = { ...currentPadding, [side]: parseInt(value) || 0 };
    handlePropertyChange('padding', newPadding);
  };

  // Specific handler for margin changes
  const handleMarginChange = (side, value) => {
    const currentMargin = properties.margin || { top: 0, right: 0, bottom: 0, left: 0 };
    const newMargin = { ...currentMargin, [side]: parseInt(value) || 0 };
    handlePropertyChange('margin', newMargin);
  };
  
  const handleBorderChange = (side,value)=>{
    const currentBoder = properties.border || { width:0, style:'solid', color:'#000000'};
    const newBorder = {...currentBoder, [side]: value};
    handlePropertyChange('border', newBorder);
  }
  return (
   <>

             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

                {/** Background Color */}
                      <Box>
                        <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                          Background Color
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                          <input
                            type="color"
                            value={properties.backgroundColor || '#ffffff'}
                            onChange={(e) => handlePropertyChange('backgroundColor', e.target.value)}
                            style={{
                              width: 40,
                              height: 40,
                              border: '1px solid #ccc',
                              borderRadius: 4,
                              cursor: 'pointer'
                            }}
                          />
                          <TextField
                            value={properties.backgroundColor || 'transparent'}
                            onChange={(e) => handlePropertyChange('backgroundColor', e.target.value)}
                            size="small"
                            variant="outlined"
                            sx={{ flexGrow: 1 }}
                          />
                        </Box>
                      </Box>
                {/** Padding */}
 <Box>
                                              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                                                Padding
                                              </Typography>
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                  <AlignVerticalTop />
                                                </Grid>
                                                <Grid size="grow">
                                                  <Slider
                                                    value={properties.padding?.top || 0}
                                                    onChange={(e, value) => handlePaddingChange('top', value)}
                                                    aria-labelledby="input-slider-padding-top"
                                                    step={1}
                                                    marks
                                                    max={80}
                                                    min={0}
                                                  />
                                                </Grid>
                                                <Grid>
                                                  <Typography variant="body2" gutterBottom>
                                                    {properties.padding?.top || 0} px
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                  
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                  <AlignHorizontalRight />
                                                </Grid>
                                                <Grid size="grow">
                                                  <Slider
                                                    value={properties.padding?.right || 0}
                                                    onChange={(e, value) => handlePaddingChange('right', value)}
                                                    aria-labelledby="input-slider-padding-right"
                                                    step={1}
                                                    marks
                                                    max={80}
                                                    min={0}
                                                  />
                                                </Grid>
                                                <Grid>
                                                  <Typography variant="body2" gutterBottom>
                                                    {properties.padding?.right || 0} px
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                  
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                  <AlignVerticalBottom />
                                                </Grid>
                                                <Grid size="grow">
                                                  <Slider
                                                    value={properties.padding?.bottom || 0}
                                                    onChange={(e, value) => handlePaddingChange('bottom', value)}
                                                    aria-labelledby="input-slider-padding-bottom"
                                                    step={1}
                                                    marks
                                                    max={80}
                                                    min={0}
                                                  />
                                                </Grid>
                                                <Grid>
                                                  <Typography variant="body2" gutterBottom>
                                                    {properties.padding?.bottom || 0} px
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                  
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                  <AlignHorizontalLeft />
                                                </Grid>
                                                <Grid size="grow">
                                                  <Slider
                                                    value={properties.padding?.left || 0}
                                                    onChange={(e, value) => handlePaddingChange('left', value)}
                                                    aria-labelledby="input-slider-padding-left"
                                                    step={1}
                                                    marks
                                                    max={80}
                                                    min={0}
                                                  />
                                                </Grid>
                                                <Grid>
                                                  <Typography variant="body2" gutterBottom>
                                                    {properties.padding?.left || 0} px
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Box>
                                  
                                            {/* Margin */}
                                            <Box>
                                              <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                                                Margin
                                              </Typography>
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                  <AlignVerticalTop />
                                                </Grid>
                                                <Grid size="grow">
                                                  <Slider
                                                    value={properties.margin?.top || 0}
                                                    onChange={(e, value) => handleMarginChange('top', value)}
                                                    aria-labelledby="input-slider-margin-top"
                                                    step={1}
                                                    marks
                                                    max={80}
                                                    min={0}
                                                  />
                                                </Grid>
                                                <Grid>
                                                  <Typography variant="body2" gutterBottom>
                                                    {properties.margin?.top || 0} px
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                  
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                  <AlignHorizontalRight />
                                                </Grid>
                                                <Grid size="grow">
                                                  <Slider
                                                    value={properties.margin?.right || 0}
                                                    onChange={(e, value) => handleMarginChange('right', value)}
                                                    aria-labelledby="input-slider-margin-right"
                                                    step={1}
                                                    marks
                                                    max={80}
                                                    min={0}
                                                  />
                                                </Grid>
                                                <Grid>
                                                  <Typography variant="body2" gutterBottom>
                                                    {properties.margin?.right || 0} px
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                  
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                  <AlignVerticalBottom />
                                                </Grid>
                                                <Grid size="grow">
                                                  <Slider
                                                    value={properties.margin?.bottom || 0}
                                                    onChange={(e, value) => handleMarginChange('bottom', value)}
                                                    aria-labelledby="input-slider-margin-bottom"
                                                    step={1}
                                                    marks
                                                    max={80}
                                                    min={0}
                                                  />
                                                </Grid>
                                                <Grid>
                                                  <Typography variant="body2" gutterBottom>
                                                    {properties.margin?.bottom || 0} px
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                  
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                  <AlignHorizontalLeft />
                                                </Grid>
                                                <Grid size="grow">
                                                  <Slider
                                                    value={properties.margin?.left || 0}
                                                    onChange={(e, value) => handleMarginChange('left', value)}
                                                    aria-labelledby="input-slider-margin-left"
                                                    step={1}
                                                    marks
                                                    max={80}
                                                    min={0}
                                                  />
                                                </Grid>
                                                <Grid>
                                                  <Typography variant="body2" gutterBottom>
                                                    {properties.margin?.left || 0} px
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Box>

                    <Box>
                                             <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                                                Border Radius
                                              </Typography>
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                    <RoundedCorner />
                                                </Grid>
                                                <Grid size="grow">
                                                <Slider
                                                    value={properties.borderRadius}
                                                    onChange={(e) => handlePropertyChange('borderRadius', e.target.value)}
                                                    aria-labelledby="input-slider-borderradius"
                                                    step={1}
                                                    marks
                                                    max= {600}
                                                />
                                                </Grid>
                                                <Grid>
                                                    <Typography variant="body2" gutterBottom>
                                                       {properties.borderRadius} px
                                                    </Typography>
                                                </Grid>
                                                
                                        </Grid>
                                            </Box>   
                     <Box>
                                             <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                                                Border Width
                                              </Typography>
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                    <BorderOuter />
                                                </Grid>
                                                <Grid size="grow">
                                                <Slider
                                                    value={properties.border.width || 0}
                                                    onChange={(e) => handleBorderChange('width', e.target.value)}
                                                    aria-labelledby="input-slider-borderwidth"
                                                    step={1}
                                                    marks
                                                    max= {20}
                                                    min={0}
                                                />
                                                </Grid>
                                                <Grid>
                                                    <Typography variant="body2" gutterBottom>
                                                       {properties.border.width} px
                                                    </Typography>
                                                </Grid>
                                                
                                        </Grid>
                                            </Box>         
                                  {/** Border Style */}
                                  <Box>
                                    <FormControl fullWidth size="small">
                                      <InputLabel>Border Style</InputLabel>
                                      <Select
                                       label="Border Style"
                                       value={properties.border.style || 'solid'} 
                                       onChange={(e) => handleBorderChange('style', e.target.value)}
                                      >
                                       <MenuItem value="solid">Solid</MenuItem>
                                          <MenuItem value="dashed">Dashed</MenuItem>
                                          <MenuItem value="dotted">Dotted</MenuItem>
                                          <MenuItem value="double">Double</MenuItem>
                                          <MenuItem value="groove">Groove</MenuItem>
                                          <MenuItem value="ridge">Ridge</MenuItem>
                                          <MenuItem value="inset">Inset</MenuItem>
                                          <MenuItem value="outset">Outset</MenuItem>
                                      </Select>
                                    </FormControl>
                                   
                                  </Box>
                                  {/** End Border Style */}   
                                  {/** Border Color */}
                                  <Box>
                                    <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                                      Border Color
                                    </Typography>
                                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                      <input type="color" value={properties.border.color || '#000000'} onChange={(e) => handleBorderChange('color', e.target.value)} style={{ width: 40, height: 40, border: '1px solid #ccc', borderRadius: 4, cursor: 'pointer' }} />
                                      <TextField value={properties.border.color || '#000000'} onChange={(e) => handleBorderChange('color', e.target.value)} size="small" variant="outlined" sx={{ flexGrow: 1 }} />
                                    </Box>
                                  </Box>
                                  {/** End Border Color */}
                                      
                {/** End Box */}
              </Box>
           
            
           
          </>
  )
}

export default ContainerBlockProperties